<template>
    <div class="layui-row attendPic">
        <header class="layui-col-md12 attend-header">
            <div class="layui-row attend-header-time">
                <div class="layui-col-md12">
                    <p>
                        <span class="YMD">{{curTime}}</span>
                        <span class="Hms">{{curTime1}}</span>
                    </p>
                </div>
                <div class="layui-col-md12">
                    <span class="head-city">{{proCity}}</span>
                    <span class="head-temp">{{skyVal}}</span>
                    <span class="head-weather"><img :src="skyIcon" /></span>
                    <span class="head-speed"> {{fengli}} </span>
                </div>
            </div>
            <div class="header-title" :style="{'font-size':tilteSize}" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;width: calc( 100% - 800px );">{{pageTitle}}</div>
            <div class="layui-row head-process">
                <el-row style="width:100%;">
                    <el-col :span="8" class="process-con1">
                        <div>
                            <p class="val1">{{progress.allDay}}</p>
                            <p class="name">总工期（天）</p>
                        </div>
                    </el-col>
                    <el-col :span="8" class="process-con1">
                        <div>
                            <p class="val2">{{progress.val}}%</p>
                            <p class="name">计划进度</p>
                        </div>
                    </el-col>
                    <el-col :span="8" class="process-con1">
                        <div>
                            <p class="val3">{{progress.otherDay}}</p>
                            <p class="name">剩余（天）</p>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="width:100%;" class="process-con1 process-con-last">
                    <el-progress :stroke-width="18" :percentage="progress.val" :show-text="false" class="process-val" status="success"></el-progress>
                </el-row>
                <!-- <div class="layui-col-md4 process-con1">
                    <div>
                        <p class="val1">{{progress.allDay}}</p>
                        <p class="name">总工期（天）</p>
                    </div>
                </div>
                <div class="layui-col-md4 process-con1">
                    <div>
                        <p class="val2">{{progress.val}}%</p>
                        <p class="name">计划进度</p>
                    </div>
                </div>
                <div class="layui-col-md4 process-con1">
                    <div>
                        <p class="val3">{{progress.otherDay}}</p>
                        <p class="name">剩余（天）</p>
                    </div>
                </div>
                <div class="layui-col-md12 process-con1 process-con-last" style="height:20px;">
                    <el-progress :stroke-width="18" :percentage="progress.val" :show-text="false"></el-progress>
                </div>-->
            </div>
            <!-- <div style="width: 100%;height: 25px;position: absolute;left: 0;bottom: 18px;text-align: center;font-size: 30px;">
                安徽省瞳声科技有限公司技术支持
            </div> -->
        </header>
        <div class="layui-col-md12 attend-second" style="display: flex;">
            <div class="attend-realName">
                <div class="attend-real-head">
                    人证比对采集+实名制管理
                </div>
                <div class="attend-real-middle">
                    <p class="attend-real-count">
                       <span class="count-left">今日采集：<span class="count-left-val1">{{collect.val}}</span>人</span>
                       <span class="count-right">历史采集：<span class="count-right-val1">{{collect.all}}</span>人</span>
                    </p>
                    <div class="attend-real-list">
                        <ul class="collectList" style="position: relative;margin:0;padding:0;">
                            <li class="list-item" v-for="item in collectList" :key="item.id">
                                <img class="list-item-left" :src="item.photo" />
                                <div class="list-item-center">
                                    <p>
                                        <span class="collect-name">{{item.name}}</span>
                                        <span class="collect-time">{{item.time}}</span>
                                    </p>
                                    <p>
                                        <span class="collect-idcard">身份证号：{{item.idcard}}</span>
                                    </p>
                                    <p>
                                        <span class="collect-tip">（人证核验采集成功）</span>
                                    </p>
                                </div>
                                <img class="list-item-rightImg" :src="item.photoImg"/>
                            </li>
                        </ul>
                    </div>
                </div>
                <hr class="real-hr" />
                <div class="attend-real-bottom">
                    <p class="attend-real-count">
                        <!-- <span class="count-left mar60">体温正常：<span class="count-left-val2">{{attend.qualifiedNum}}</span></span> -->
                        <span class="count-left mar60 font-color2" v-if="projectId!=='1648193307227910145'">体温异常：<span class="count-left-val4">{{attend.notQualifiedNum}}</span></span>
                        <span class="count-left mar60 font-color2" v-if="projectId!=='1648193307227910145'">安康码异常：<span class="count-left-val4">{{attend.anKangCodeCount}}</span></span>
                        <span class="count-left mar60">出勤：<span class="count-left-val3">{{attend.attend}}</span></span>
                        <span class="count-right">在场：<span class="count-right-val2">{{attend.status}}</span></span>
                    </p>
                    <div class="attend-real-list" style="padding-top:10px;">
                        <ul class="attendList" style="margin:0;position: relative;">
                            <li class="list-item" style="height: 160px;" v-for="item in attendList" :key="item.id">
                                <img class="list-item-left1" :src="item.photoImg" />
                                <div class="list-item-con">
                                    <p>
                                        <span class="entry-name">{{item.name}}</span>
                                    </p>
                                    <p>
                                        <span class="entry-class">{{item.teamsName}}</span>
                                    </p>
                                </div>
                                <div class="list-item-anKang" v-if="projectId!=='1648193307227910145'">
                                    <img :src="item.anSrc" style="width:94px;height:94px;" />
                                    <p style="width:100%;text-align: center;">安康码</p>
                                </div>
                                <div class="list-item-right">
                                    <p>
                                        <span class="entry-type">{{item.statusName}}</span>
                                        <span class="entry-time">{{item.time}}</span>
                                    </p>
                                    <p>
                                        <span class="entry-chu">出勤：</span>
                                        <span class="entry-chuDay">{{item.dayss}}/天</span>
                                        <span class="entry-chu" style="margin-left:20px;" v-if="projectId!=='1648193307227910145'">体温：</span>
                                        <span class="entry-chuDay" :class="[item.temperatureFlag?'font-color1':'font-color2']" v-if="projectId!=='1648193307227910145'">{{item.temperature}}℃</span>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="attend-rightCon">
                <div class="attend-r-head">
                    <el-button type="button" class="layui-btn layui-btn-lg layui-btn-radius videoBtn layui-btn-normal cur" round @click="openVideo">视频</el-button>
                    <el-button type="button" class="layui-btn layui-btn-lg layui-btn-radius loopBtn" round @click="openPic">轮播</el-button>
                </div>
                <div class="attend-r-con" > 
                    <div class="con-video">
                        <video ref="videoPlay" autoplay loop controls poster="" id="bgvid">
                            <source :src="passVideo" />
                        </video>
                    </div>
                    <div class="con-carousel" style="height:100%;width:100%;display:none;">
                        <el-carousel indicator-position="none" height="100%">
                            <el-carousel-item v-for="item in proImg" :key="item" style="width:100%;height:100%;display:flex;justify-content: center;align-items: center;">
                                <img :src="item" style="max-width:100%;max-height:100%;"/>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <div v-if="errorFlag" style="position: absolute;bottom: 8px;right:0px;width:100%;height:40px;color: red;background: #fff;padding: 0 20px;text-align: right;font-size: 22PX;line-height: 44px;">
                服务连接异常，请检查网络！
            </div>
        </div>
        <div id="bdtts_div_id">
            <audio id="tts_autio_id" autoplay="autoplay" mute="true">
            <source id="tts_source_id" src="http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=9&text= " type="audio/mpeg">
            <embed id="tts_embed_id" height="0" width="0" src="">
            </audio>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port';
// import $ from 'jquery'

import axios from '../../untils/http'
import base from '../../untils/base'
import util from "../../untils/util.js"
export default {
    data(){
        return{
            video:'',//视频
            curTime:'',//日期时间
            curTime1:'',//时间
            skyVal:'',//温度
            skyIcon:require('../../assets/image/weather/duoyun.png'),//天气图标
            fengli:'',//风力
            proCity:'合肥市',//城市
            tilteSize:'60px',
            progress:{  //进度参数
                allDay:0,
                val:0,
                other:0
            },
            projectId:'',//传递的项目id
            pageTitle:'',//页面项目名称
            collect:{  //采集人员数量
                val:0,
                all:0
            },
            attend:{ //考勤人员数量
                inJob:0,
                attend:0,
                out:0,
                anKangCodeCount:0,
                status:0
            },
            websocket:'',//..web推送
            timeOutObj:'',//循环定时器
            collectList:[],//采集列表
            attendList:[],//考勤列表
            proImg:'',
            index:0,
            broadList:[],//播报列表
            isBroad:false,//语音是否在播放中  false:否  true:是
            baiduToken:'',//百度语音token
            errorFlag:false,//错误提示
            passVideo:'',//视频
        }
    },
    mounted(){
        var params = this.$route.params;
        this.projectId = params.id;
        // this.projectId =  util.session.get('groupId')
        var that = this;
        setInterval(function(){
            var date = new Date();
            that.curTime = that.formatTime(date,'YYYY-MM-dd');
            that.curTime1 = that.formatTime(date,'HH:mm:ss');
        },1000);
        this.video = document.getElementById('bgvid');
        // this.getWeather();
        this.getData();
        this.initWebsocket();//socket推送
        this.getVideoList()
        // that.testFun();
        /**
        * 监听网络
        */
        var el = document.body;  
        if (el.addEventListener) {  
            window.addEventListener("online", function () {
                that.initWebsocket();
                clearTimeout(that.timeOutObj);
                that.getAttendData();//展示考勤数量
                that.getCollerctData();//展示采集数量
            }, true);  
            window.addEventListener("offline", function () {  
                that.websocket.close();
            }, true);  
        }
        else if (el.attachEvent) {  
            window.attachEvent("ononline", function () {  
                that.initWebsocket();
                clearTimeout(that.timeOutObj);
                that.getAttendData();//展示考勤数量
                that.getCollerctData();//展示采集数量
            });  
            window.attachEvent("onoffline", function () {  
                that.websocket.close();
            });  
        }  
        else {  
            window.ononline = function () {  
                that.initWebsocket();
                clearTimeout(that.timeOutObj);
                that.getAttendData();//展示考勤数量
                that.getCollerctData();//展示采集数量
            };  
            window.onoffline = function () {  
                that.websocket.close();
            };  
        }

        // this.getBaiduToken();
    },
    methods:{
        // testFun(){
        //     var that = this;
        //     this.index++;
        //     this.showInOutPerson({
        //         id:this.index,
        //         name:'张三'+this.index,
        //         idcardfile:"/image/template/idcard/342201196604054734.jpg",
        //         clocktime:new Date(),
        //         idcard:'123456789456',
        //         photofile:'/image/template/idcard/342201196604054734.jpg'
        //     });
        //     if(this.index<10){
        //         setTimeout(function(){
        //             that.testFun();
        //         },10000);
        //     }
        // },
        openVideo(){
            $(".con-video").show();
            $(".con-carousel").hide();
            $(".loopBtn").removeClass("cur");
            $(".videoBtn").addClass("cur");
            this.video.play();
        },
        openPic(){
            $(".con-video").hide();
            $(".con-carousel").show();
            $(".videoBtn").removeClass("cur");
            $(".loopBtn").addClass("cur");
            this.video.pause();
        },
        formatTime(time,format){
            var time = time?new Date(time):new Date();
            var year = time.getFullYear();
            var month = (time.getMonth() + 1).toString().length == 1 ? "0" + (time.getMonth() + 1).toString() : (time.getMonth() + 1);
            var day = time.getDate().toString().length == 1 ? "0" + time.getDate() : time.getDate();
            var hour = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
            var m = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
            var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
            var result = format.replace('YYYY',year).replace('MM',month).replace('dd',day).replace('HH',hour).replace('mm',m).replace('ss',s);
            return result;
       },
       //获取天气
       getWeather(){
            var that = this;
            // $.ajax({
            //     url:'http://wthrcdn.etouch.cn/weather_mini',
            //     method:'get',
            //     data:{city: '合肥市'},
            //     dataType: 'jsonp',
            //     success:function(resp){
            //         that.skyVal = resp.data.forecast[0].low.split(' ')[1] + '~' + resp.data.forecast[0].high.split(' ')[1];
            //         that.skyIcon = that.getSkyIcon(resp.data.forecast[0].type);
            //         that.fengli = resp.data.forecast[0].fengli.split('[')[2].split(']')[0];
                    
            //     },
            //     error:function(){}
            // }) 
            // axios.get('http://wthrcdn.etouch.cn/weather_mini?city='+this.proCity).then(function(resp){
            //  console.log(resp)
            //  var resp =resp.data
            //   that.skyVal = resp.data.forecast[0].low.split(' ')[1] + '~' + resp.data.forecast[0].high.split(' ')[1];
            //   that.skyIcon = that.getSkyIcon(resp.data.forecast[0].type);
            //   that.fengli = resp.data.forecast[0].fengli.split('[')[2].split(']')[0];
            // })
            // .catch(function(error){
            //  console.log(error)
            // })


       },
       //获取天气图片
       getSkyIcon(type){
            if(type=='多云'){
                return require('../../assets/image/weather/duoyun.png');
            }else if(type=='晴天'||type=='晴'){
                return require('../../assets/image/weather/qin.png');
            }else if(type=='阴'){
                return require('../../assets/image/weather/yin.png');
            }else if(type.indexOf("雨")>-1){
                return require('../../assets/image/weather/yu.png');
            }else if(type.indexOf("雪")>-1){
                return require('../../assets/image/weather/xue.png');
            }else{
                return require('../../assets/image/weather/duoyun.png');
            }
        },
        //获取数据
        getData(){
            console.log('数据开始展示')
            var that = this;
            myHttp.getViewScreenById({
                projectId:this.projectId
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var pro = resp.data.data.project;
                    that.pageTitle = pro.name;
                    that.tilteSize = pro.name.length>18?1080/parseInt(pro.name.length)+'px':'60px';
                    var photoList = pro.photoPath && pro.photoPath!=''?pro.photoPath.split(','):[];//项目图片
                    var data = resp.data.data;
                    data.allDay = data.allDay?parseInt(data.allDay):0;//总工期
                    data.otherDay = data.otherDay?parseInt(data.otherDay):0;//剩余工期
                    that.showProcess(data.allDay,data.otherDay);//展示进度
                    that.showCollect(data.tdGather,data.allGather);//展示采集人数
                    that.showIn(data.inJob,data.outJob,data.inAttend,data.inStatus,data.qualifiedNum,data.notQualifiedNum,data.anKangCodeCount);//展示入场人数
                    var list = [];
                    for(var i=0;i<photoList.length;i++){
                        if(photoList[i]&&photoList[i]!=''){
                            var str = base.httpCtx + photoList[i];
                            list.push(str);
                        }
                    }
                    that.proImg = list;
                    that.setAreaFun(pro.areaId)
                }
            });
        },
        //获取区域
        setAreaFun(id) {
          if ('' == id || undefined == id) {
              this.getWeather()
              return
          }
          var that = this
          myHttp.getAreaById({
            id: id
          }).then(function(resp) {
            if (resp.data.code == '200') {
                var city = resp.data.data.area.cityName
                var area = resp.data.data.area.name
                that.proCity = city.indexOf('市')>0?city:area
            }
            that.getWeather()
          },function(error) {})
        },
        //展示工期进度
        showProcess(all,other){
            var process = 0;
            if(all!=0){
                process = (all-other)/all*100;
                process = process.toFixed(2);
            }
            this.progress.val = parseFloat(process);
            this.progress.allDay = all;
            this.progress.otherDay = other;
        },
        //展示采集人员数量   tdGather:今日采集人数     allGather：总采集人数
        showCollect(tdGather,allGather){
            this.collect.val = tdGather;
            this.collect.all = allGather;
        },
        //展示入场人数    injob:在职   out:离职   attend：出勤     status：在场
        showIn(injob,out,attend,status,qualifiedNum,notQualifiedNum,anKangCodeCount){
           this.attend.inJob = injob;
           this.attend.out = out;
           this.attend.attend = attend;
           this.attend.status = status;
           this.attend.qualifiedNum = qualifiedNum;
           this.attend.notQualifiedNum = notQualifiedNum;
           this.attend.anKangCodeCount = anKangCodeCount||0
        },
        //根据id,可视化大屏刷新采集信息
        getCollerctData(){
            var that = this;
            myHttp.getViewScreenGatherById({
                projectId:this.projectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data;
                    that.showCollect(data.tdGather,data.allGather);//展示采集人数
                }
            });
        },
        //根据id,可视化大屏刷新考勤信息
        getAttendData(){
            var that = this;
            myHttp.getViewScreenAttendById({
                projectId:this.projectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data;
                    that.showIn(data.inJob,data.outJob,data.inAttend,data.inStatus,data.qualifiedNum,data.notQualifiedNum,data.anKangCodeCount);//展示入场人数
                }
            });
        },
        //展示当前采集人员
        showCollectPerson(data){
            var imgUrl = base.httpCtx;
            var time = this.formatTime(data.clocktime,'YYYY-MM-dd HH:mm:ss');
            data.time = time;
            data.photo = imgUrl+data.idcardfile;
            data.photoImg = imgUrl+data.photofile;
            // this.collectList.push(data);
            // var that = this;
            // if(this.collectList.length>2){
            //     var h = -$($('.collectList').find('.list-item')[0]).height()-30;
            //     $(".collectList").animate({top:h},1000, function() {
            //         $($(".collectList").find("li")[0]).remove();
            //         $(".collectList").css("top","0px");
            //         that.collectList.shift();
            //     });
            // }
            this.collectList.unshift(data);
            $(".collectList").css('top','-160px')
            $(".collectList").animate({top:'0px'},1000);
       },
       //展示入场人员
       showInOutPerson(data){
           var imgUrl = base.httpCtx;
           var statusName = data.status=='0'?'进闸':'出闸';
           var time = this.formatTime(data.clocktime,'YYYY-MM-dd HH:mm:ss');
           if(data.photofile){
               data.photoImg = imgUrl+data.photofile;
           }else{
               data.photoImg = imgUrl+data.photoFile;
           }
           data.time = time;
           data.statusName = statusName;
           data.temperatureFlag = parseFloat(data.temperature)>37.3?false:true;
           if(data.healthLevel=='2'){
               data.anSrc = require("../../assets/image/anKang-yellow.png")
           }else if(data.healthLevel=='3'){
               data.anSrc = require("../../assets/image/anKang-red.png")
           }else if(data.healthLevel=='1'){
               data.anSrc = require("../../assets/image/anKang-gress.png")
           }else{
               data.anSrc = require("../../assets/image/anKang-no.png")
           }
        //    this.attendList.push(data);
            this.attendList.unshift(data);
           var that = this;
           // $(".attendList").css('top','-160px')
           // $(".attendList").animate({top:'0px'},1000);
        //    var html ='<li class="list-item" style="height: 160px;"><img class="list-item-left1" src="'+imgUrl+data.photofile+'" />'
        //             + '<div class="list-item-con"><p><span class="entry-name">'+data.name+'</span></p>'
        //             + '<p><span class="entry-class">'+data.teamsName+'</span></p></div>'
        //             + '<div class="list-item-right">'
        //             + '<p><span class="entry-type">'+statusName+'</span><span class="entry-time">'+time+'</span></p>'
        //             + '<p><span class="entry-chu">出勤：</span><span class="entry-chuDay">'+data.dayss+'/天</span></p>'
        //             + '</div></li>';
        //    $('.attendList').append(html);
        //    console.log(this.attendList.length,this.attendList)
        // //    if($('.attendList').find('.list-item').length>2){
        //     if(this.attendList.length>2){
        //         var h = -$($('.attendList').find('.list-item')[0]).height()-30;
        //         console.log(h)
        //         $(".attendList").animate({top:h},1000, function() {
        //             // $($(".attendList").find("li")[0]).remove();
        //             $(".attendList").css("top","0px");
        //             that.attendList.shift();
        //             console.log(that.attendList)
        //         });
        //     }
       },
       /**
        * socket推送
        */
        initWebsocket(){
            var that = this;
            //判断当前浏览器是否支持WebSocket
            if('WebSocket' in window){
                var url = ''
                if(document.location.protocol=="https:"){
                    url = base.httpsWs+"/websocket/"+this.projectId;//wss地址;
                }else{
                    url = base.httpWs+"/websocket/"+this.projectId;//ws地址;
                }
                // var url=base.httpWs+"/websocket/"+this.projectId;
                that.websocket = new WebSocket(url);
            }
            else{
                alert('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function(){
                //setMessageInnerHTML("error");
            };
            //连接成功建立的回调方法
            this.websocket.onopen = function(event){
             
                //$("#serverinfo").hide();
                that.errorFlag = false
                that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function(event){
                if(event.data=="连接成功")return;
                var x=JSON.parse(event.data);
                if("1"==x.flag){
                    // alert(x.msg);
                    // that.closeWebSocket();
                    that.showInOutPerson(x.entity);
                    that.broadList.push(x.entity);
                    if(!that.isBroad){
                        that.video.pause();//暂停视频
                        that.showAuido();//播报语音
                    }
                }
                if("2"==x.flag){
                    console.log(x)
                    that.showInOutPerson(x);
                    that.getAttendData();//展示考勤数量
                    that.broadList.push(x);
                    if(!that.isBroad){
                        that.video.pause();//暂停视频
                        that.showAuido();//播报语音
                    }
                    
                }
                if("3"==x.flag){
                    that.showCollectPerson(x);
                    that.getCollerctData();//展示采集数量
                }
            }
            //连接关闭的回调方法
            this.websocket.onclose = function(){
                this.timeOutObj=setTimeout(function(){
                    that.initWebsocket();
                }, 60000);
                // $("#serverinfo").show();
                that.errorFlag = true
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function(){
                that.websocket.close();
            }
        },
        //关闭连接
        closeWebSocket(){
            that.websocket.close();
        },

        //语音播报
        showAuido(data){
            this.isBroad = true;
            var data = this.broadList.shift()
            var ttsDiv = document.getElementById('bdtts_div_id');
            var ttsAudio = document.getElementById('tts_autio_id');
            //var status = data.status=='0'?'进闸':'出闸'
            var times = 0
            if(data.temperature && data.temperature!=''){
                var status = parseFloat(data.temperature)>37.3?'体温异常，限制进入':'';
                times = parseFloat(data.temperature)>37.3?6000:3500;
                var ttsText = ' '+data.name+', '+data.temperature+'度,'+status;
                
                // ttsDiv.removeChild(ttsAudio);
                // var au1 = '<audio id="tts_autio_id" autoplay="autoplay">';
                // var sss = '<source id="tts_source_id" src="http://tts.baidu.com/text2audio?cuid="+this.projectId+"&ctp=1&vol=15&lan=zh&spd=5&tex="+ttsText+"&token=24.30b37cfd2a8652ba7189a703c9aea230.2592000.1585282197.282335-18584605" type="audio/mpeg">';
                // var eee = '<embed id="tts_embed_id" height="0" width="0" src="">';
                // var au2 = '</audio>';
                // ttsDiv.innerHTML = au1 + sss + eee + au2;
                // ttsAudio = document.getElementById('tts_autio_id');
                // ttsAudio.play();
                new Audio(
                    'http://tts.baidu.com/text2audio?cuid=baiduid&ctp=1&vol=15&lan=zh&per=1&pit=9&spd=5&tex='+ttsText+'&tok='+base.videoToken
                ).play();
            }
            var that = this;
            setTimeout(function(){
                if(that.broadList.length>0){
                    that.showAuido()
                }else{
                    that.isBroad = false;
                    that.video.play();//视频播放
                }
            },times);
        },
        // 获取视频列表
        getVideoList(){
          var that =this ;
        //   findPassVideo 
            myHttp.findPassVideo({
                projectId:this.projectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    if(resp.data.data.passVideo){
                         var data = resp.data.data.passVideo;
                        that.passVideo  =base.httpCtx+data.videoUrl
                    }else{
                        that.passVideo ='http://47.100.89.71:18004/static/wisdom/video/safe.mp4'
                    }
                    that.$nextTick(() => {
                        that.$refs.videoPlay.load();
                        that.$refs.videoPlay.play()
                    })
                }
            });
        }
        /**
         * 获取百度语音token
         */
        // getBaiduToken(){
        //     myHttp.baiduOauth({
        //         grant_type:'client_credentials',
        //         client_id:'3FbCejnkS4fmnKv6mo0anczF',
        //         client_secret:'DMYpiXG0P4jBbGdTG7sDtOWYZYzfsOU1'
        //     }).then(function(resp){
        //         console.log(resp)
        //     },function(){});
        // },

    }
}
</script>
<style scoped>
    *{font-size: 18px;box-sizing: border-box;}.head-process p{text-align: center;font-weight: bold;color: #707070;}
    #bgvid{width:100%;height:100%;background: #000;}.YMD{margin-right: 20px;font-weight: bold;color: #707070;}
    .Hms{font-weight: bold;color: #707070;}.attendPic{width: 1920px;height: 100vh;}
    .attend-header{width: 100%;height:178px;display: flex;padding: 20px;box-sizing: border-box;border-bottom: 1px solid #707070;position: relative;}
    .attend-header-time{width:400px;} .attend-header-time div{display: flex;justify-content:flex-start;margin: 10px 0 20px;}
    .head-city{margin-right: 20px;font-weight: bold;color: #707070;font-size: 28px;}
    .head-temp{margin-right: 20px;font-weight: bold;color: #F29F11;font-size: 28px;}
    .head-weather{margin-right: 20px;}.head-weather img{width: 30px;height:30px;}.head-speed{font-weight: bold;color: #707070;font-size: 28px;}
    /* .header-title{flex-grow:1;display: flex;justify-content: center;align-items: center;font-size: 60px;color: #4D63FF;font-weight: bold;padding-top: 5px;} */
    .header-title{font-size: 60px;color: #4D63FF;font-weight: bold;padding-top: 5px;line-height: 122px;}
    .head-process{width:400px;display: flex;align-items: center;align-content: center;flex-wrap: wrap;}
    .head-process .process-con1{display: flex;justify-content: center;}.process-con-last{margin-top:10px;}
    .process-con1 .val1,.process-con1 .val2,.process-con1 .val3{font-size:32px;}.process-con1 .name{font-size:15px;font-weight: bold;}
    .attend-realName{width: 706px;display: flex;flex-wrap: wrap;align-content: center;}.count-left.mar60{margin-right: 0px;}
    .attend-real-head{height: 64px;width: 100%;font-size: 32px;text-align: center;font-weight: bold;background: #EDEEF2;padding-top:9px;}
    .attend-real-middle{height: 408px;display: flex;padding: 10px 0 10px 20px;overflow: hidden;flex-wrap: wrap;width: 100%;}
    .attend-real-count{width: 100%;text-align: center;display: flex;justify-content: space-around;height: 40px;}
    .count-left{font-size: 28px;margin-right: 100px;color: #4D63FF;font-weight: bold;}.count-right{font-size: 30px;color: #4D63FF;font-weight: bold;}
    .count-left-val1,.count-right-val1,.count-left-val2,.count-left-val3,.count-left-val4,.count-right-val2{font-size: 30px;}
    .attend-real-list{width:100%;height:358px;overflow: hidden;}.list-item{padding: 15px 0;display: flex;height: 166px;width: 100%;align-content: center;}
    .list-item-left{height: 136px;width: 113px;}.list-item-center{flex:1;display: flex;padding-left: 20px;flex-wrap: wrap;}
    .list-item-center p{width: 100%;height: 40px;margin-bottom: 10px;}
    .collect-name{font-weight: bold;font-size:30px;font-weight: bold;margin-right: 50px;}
    .collect-time{font-size: 22px;font-weight: bold;color: rgba(0, 0, 0, 0.5);}
    .collect-idcard{font-size: 22px;font-weight: bold;color: rgba(0, 0, 0, 0.5);}
    .collect-tip{font-size: 22px;font-weight: bold;color: #4D63FF;}.list-item-rightImg{height: 136px;width: 115px;}
    .real-hr{height: 10px;background:#EDEEF2;width: 100%;margin: 0;border: 0;}
    .attend-real-bottom{height: 408px;display: flex;padding: 10px 0 10px 20px;overflow: hidden;flex-wrap: wrap;width: 100%;}
    .list-item-left1{height: 130px;width: 100px;}.list-item-con p,.list-item-right p{width: 100%;height: 40px;margin-bottom: 10px;text-align: left;}
    .list-item-con{flex:1;display: flex;padding-left: 20px;flex-wrap: wrap;margin-top: 20px;}
    .entry-name{font-weight: bold;font-size:30px;font-weight: bold;}
    .entry-class{font-size: 22px;font-weight: bold;color: rgba(0, 0, 0, 0.5);display: inline-block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
    .list-item-right{width: 330px;display: flex;padding-left: 20px;flex-wrap: wrap;margin-top: 20px;}
    .entry-chu,.entry-chuDay{font-size: 22px;font-weight: bold;color: rgba(0, 0, 0, 0.5);}
    .entry-type{font-weight: bold;font-size:22px;margin-right: 10px;}
    .entry-time{font-weight: bold;font-size:22px;}.attend-rightCon{width: calc( 100% - 706px );}
    .attend-r-head{height: 64px;width: 100%;font-size: 32px;text-align: center;font-weight: bold;background: #EDEEF2;padding-top: 9px;}
    .videoBtn{margin-right: 100px;} .videoBtn,.loopBtn{width:240px;background: rgba(77, 99, 255, 0.1);color: #4D63FF;}
    .videoBtn:hover,.loopBtn:hover,.videoBtn.cur,.loopBtn.cur{background-color: #1E9FFF;color:#fff;}
    .attend-r-con{width: 100%;height:826px;padding: 10px 0px 0 20px;box-sizing: border-box;}
    .con-video{width: 100%;height: 100%;}p{margin: 0}
    .process-val{height: 20px;width: 100%;}
    .el-carousel__item,.el-carousel{width: 100%;height: 100%;}
    .font-color1{color: #67C23A}
    .font-color2{color: red}
    .list-item-anKang{width:100px;height:100%;position: relative;display: flex;flex-wrap: wrap; align-content: center;align-items: center;justify-content: center;justify-items: center;}
</style>